import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a walnut lectern/pulpit about 1.2 high: a solid base,
// a tapering body, a slanted reading top (reader stands at -Z, audience at
// +Z) and a thin gold trim strip on the front.
const WOOD = "#7a5a3a";
const WOOD_DARK = "#6b4e33";
const GOLD = "#c9a24b";

export const pulpit = defineModel({
  id: "pulpit",
  batchId: "modern",
  name: "Pulpit",
  tags: ["modern", "interior", "furniture", "church", "lectern", "pulpit"],
  summary: "A walnut lectern with a slanted top and gold trim.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // solid base
      { geometry: new THREE.BoxGeometry(0.56, 0.14, 0.5), color: WOOD_DARK, position: [0, 0.07, 0] },
      // body column
      { geometry: new THREE.BoxGeometry(0.46, 0.88, 0.38), color: WOOD, position: [0, 0.58, 0] },
      // thin gold trim strip across the front (+Z)
      { geometry: new THREE.BoxGeometry(0.46, 0.03, 0.02), color: GOLD, position: [0, 0.86, 0.2] },
      // slanted reading top (lower edge toward the reader at -Z)
      { geometry: new THREE.BoxGeometry(0.56, 0.05, 0.46), color: WOOD_DARK, position: [0, 1.1, 0], rotation: [-0.3, 0, 0] },
      // book-stop lip at the lower edge of the slant
      { geometry: new THREE.BoxGeometry(0.56, 0.05, 0.04), color: WOOD, position: [0, 1.06, -0.21] },
    ];
  },
  animations: [],
});
